import React, { useState, useEffect } from "react";
import { Grid, Card, Container, CardContent, Typography, CardMedia, Button, Box, IconButton, Snackbar, Alert, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';

// Import custom components and services
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../components/Loaders/DnaLoader";
import "../../../assets/custom css/loadoverlay.scss";
import Alerts from "../../../components/Alerts/alerts";
import AuthService from "../../Authentication_usertypes/auth.service";
import AlertService from "../../../components/Alerts/alerts";
import DashboardService from "../dashboard.service";

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[8],
  },
}));

const StyledCardMedia = styled(CardMedia)({
  height: 200,
  objectFit: 'cover',
});

const StyledButton = styled(Button)(({ theme }) => ({
  fontWeight: 'bold',
  padding: theme.spacing(1.5, 3),
}));



const FeaturedProducts = ({ selectedCategory, selectedBranch }) => {
  const [products, setProducts] = useState([]);
  const [tempCart, setTempCart] = useState([]);
  const [selectedVariations, setSelectedVariations] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSnackbar1, setOpenSnackbar1] = useState(false);
  const [openSnackbar2, setOpenSnackbar2] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    fetchExistingCart();
  }, []);

  const fetchExistingCart = async () => {
    try {
      setLoading(true);
      const userString = localStorage.getItem('user');
      const user = JSON.parse(userString);
      const userId = user['_id'];
      const updateData = {
        "functionName": "GetCartList",
        "postData": {
          "user_id": userId,
          "filters": {
            "status": false,
            "coupan_code": '',
            "prioritize": "",
            "quantity": {
              "cart_id": '',
              "quantity": ''
            }
          }
        }
      };
      const response = await DashboardService.GetCartList(updateData);
      if (response.data && response.data.cartData) {
        const existingCartItems = response.data.cartData.map(item => ({
          business_id: item.business_details._id,
          category_id: item.category_details._id,
          product_id: item.product_details._id,
          quantity: parseInt(item.quantity),
          price: parseFloat(item.price),
          variations: item.variations || []
        }));
        setTempCart(existingCartItems);
      }
    } catch (error) {
      console.error('Error fetching existing cart:', error);
    } finally {
      setLoading(false);
    }
  };




  const handleVariationChange = (product, variationGroup, type, isChecked) => {
    setTempCart(prev => {
      const productIndex = prev.findIndex(item => item.product_id === product._id);
      if (productIndex === -1) return prev; // Product not in cart, do nothing

      const updatedCart = [...prev];
      const cartItem = {...updatedCart[productIndex]};
      
      if (isChecked) {
        cartItem.variations.push({
          variation_id: variationGroup.Variation._id,
          variation_name: variationGroup.Variation.name,
          variation_option_id: type._id,
          variation_type_name: type.variation_type_name,
          variation_price: parseFloat(type.price)
        });

        console.log('Updated cart item:', cartItem);
        
      } else {
        cartItem.variations = cartItem.variations.filter(
          v => !(v.variation_id === variationGroup.Variation._id && v.variation_option_id === type._id)
        );
      }

      // Recalculate total price
      const basePrice = parseFloat(cartItem.price);
      const variationTotal = cartItem.variations.reduce((sum, v) => sum + v.variation_price, 0);
      cartItem.total_price = (basePrice + variationTotal) * cartItem.quantity;

      updatedCart[productIndex] = cartItem;
      return updatedCart;
    });
  };

  const handleIncrement = (product) => {
    setTempCart(prev => {
      const existingProductIndex = prev.findIndex(item => item.product_id === product?._id);
      
      if (existingProductIndex > -1) {
        const updatedCart = [...prev];
        updatedCart[existingProductIndex] = {
          ...updatedCart[existingProductIndex],
          quantity: updatedCart[existingProductIndex].quantity + 1,
          total_price: (updatedCart[existingProductIndex].quantity + 1) * 
            (parseFloat(product?.amount) + updatedCart[existingProductIndex].variations.reduce((sum, v) => sum + v.variation_price, 0))
        };
        return updatedCart;
      } else {
        return [
          ...prev,
          {
            business_id: product?.business_id,
            category_id: product?.category,
            product_id: product?._id,
            quantity: 1,
            price: product?.amount,
            variations: [],
            total_price: parseFloat(product?.amount)
          }
        ];
      }
    });
  };

  const handleDecrement = (product) => {
    setTempCart(prev => {
      const existingProductIndex = prev.findIndex(item => item.product_id === product?._id);
      if (existingProductIndex > -1) {
        if (prev[existingProductIndex].quantity > 1) {
          const updatedCart = [...prev];
          const itemTotalPrice = parseFloat(product?.amount) + 
            updatedCart[existingProductIndex].variations.reduce((sum, v) => sum + v.variation_price, 0);
          updatedCart[existingProductIndex] = {
            ...updatedCart[existingProductIndex],
            quantity: updatedCart[existingProductIndex].quantity - 1,
            total_price: (updatedCart[existingProductIndex].quantity - 1) * itemTotalPrice
          };
          return updatedCart;
        } else {
          return prev.filter(item => item.product_id !== product?._id);
        }
      }
      return prev;
    });
  };

  const handlePlaceOrder = () => {
    if (tempCart.length === 0) {
      setOpenSnackbar(true);
    } else {
      let user = JSON.parse(localStorage.getItem('user'));
      if (user && user._id) {
        setCart(user._id);
      } else {
        setShowLoginPopup(true);
      }
    }
  };

  const setCart = (userId) => {
    const payload = {
      "functionName": "SetCart",
      user_id: userId,
      "postData": tempCart
    };
    console.log("payload setCart", payload)
    DashboardService.setCart(payload)
      .then((response) => {
        if(response.data.status===false)
        {
          AlertService.swalErrorAlert(t(response.data.message));
        }
        else
        {
          setOpenSnackbar1(true);
          console.log('Cart set successfully:', response);
          navigate('/CartView');
        }
        
      })
      .catch((error) => {
        console.error('Error setting cart:', error);
        AlertService.swalErrorAlert(t("Error setting cart. Please try again."));
      });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleCloseSnackbar1 = () => {
    setOpenSnackbar1(false);
  };

  const handleCloseSnackbar2 = () => {
    setOpenSnackbar2(false);
  };

  useEffect(() => {
    if (selectedCategory !== undefined) {
      fetchProducts(0, pageLimit)
    }
  }, [selectedCategory, selectedBranch]);

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
  }, []);

  function fetchProducts(page_index, page_limit) {
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }

    setLoading(true);
    let Branch = [];
    if (selectedBranch !== '') {
      Branch.push(selectedBranch)
    }
    let Category = [];
    if (selectedCategory !== '') {
      Category.push(selectedCategory)
    }
    if (selectedCategory !== '') {
      DashboardService.getAllProducts(offset, page_limit, Category, Branch).then((response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        }
        else {
          if (response.data.data) {
            console.log("ALL Products", response.data.data);
            setProducts(response.data.data);
          }
        }
      },
      (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
    }
  };

  const getProductQuantity = (productId) => {
    const cartItem = tempCart.find(item => item.product_id === productId);
    return cartItem ? cartItem.quantity : 0;
  };

  return (
    <Box sx={{ py: 4, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 'bold', color: 'text.primary' }}>
          Products
        </Typography>
        {products.length === 0 ? (
          <Typography variant="body1" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
            No products available for the selected category
          </Typography>
        ) : (
          <Grid container spacing={3}>
            {products.map((product) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={product?._id}>
                <StyledCard>
                  <StyledCardMedia
                    component="img"
                    alt={product?.Images?.[0] || 'Product image'}
                    image={product?.Images?.[0] || 'placeholder-image-url'}
                    title={product?.item_name}
                  />
                  
                  <CardContent>
                    <NavLink to={`/ProductDetails/${product?._id}`}>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'medium' }}>{product?.item_name}</Typography>
                    </NavLink>

                    <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 'bold', mb: 2 }}>
                      ${parseFloat(product?.amount).toFixed(2)}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 }}>
                      <IconButton onClick={() => handleDecrement(product)} size="small" color="primary">
                        <RemoveIcon />
                      </IconButton>
                      <Typography variant="body1" sx={{ mx: 2, fontWeight: 'medium' }}>
                        {getProductQuantity(product?._id)}
                      </Typography>
                      <IconButton onClick={() => handleIncrement(product)} size="small" color="primary">
                        <AddIcon />
                      </IconButton>
                    </Box>

                    {getProductQuantity(product?._id) > 0 && product.GroupedVariations && (
                      <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'medium' }}>
                          Select Variations:
                        </Typography>
                        {product.GroupedVariations.map((variationGroup) => (
                          <Box sx={{ mb: 2 }} key={variationGroup.Variation._id}>
                            <Typography variant="body2" gutterBottom>
                              {variationGroup.Variation.name}
                            </Typography>
                            <FormGroup row>
                              {variationGroup.VariationTypes.map((type) => (
                                <FormControlLabel
                                  key={type._id}
                                  control={
                                    <Checkbox
                                      name={type.variation_type_name}
                                      color="primary"
                                      size="small"
                                      onChange={(e) => handleVariationChange(
                                        product,
                                        variationGroup,
                                        type,
                                        e.target.checked
                                      )}
                                    />
                                  }
                                  label={
                                    <Typography variant="body2">
                                      {type.variation_type_name} (+${parseFloat(type.price).toFixed(2)})
                                    </Typography>
                                  }
                                />
                              ))}
                            </FormGroup>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </CardContent>
                </StyledCard>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>


      <Box sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'background.paper',
        padding: 2,
        boxShadow: 3,
        zIndex: 1000,
      }}>
        <Container maxWidth="lg">
          <StyledButton variant="contained" color="primary" fullWidth onClick={handlePlaceOrder}>
            Proceed to Cart
          </StyledButton>
        </Container>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          Please select at least one item.
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackbar1}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar1}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar1} severity="success" sx={{ width: '100%' }}>
          Proceed to cart.
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackbar2}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar2}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar2} severity="warning" sx={{ width: '100%' }}>
          Please Login First.
        </Alert>
      </Snackbar>
    </Box>
  );
};



export default FeaturedProducts;
